import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Groups API
 */
class GroupApi extends ApiBase {
  async getActiveNonAdminGroups() {
    const request = {
      url: `${this.API_URL}/groups?orderBy=name&orderDirection=ASC&adminGroup=false&status=ACTIVE`,
      headers: this.getHeaders(),
      method: 'GET'
    };

    const response = await axios.request(request);

    return response.data;
  }
}

export default new GroupApi();
